import { render, staticRenderFns } from "./projectlist.vue?vue&type=template&id=d09346f8&scoped=true"
import script from "./projectlist.vue?vue&type=script&lang=js"
export * from "./projectlist.vue?vue&type=script&lang=js"
import style0 from "./projectlist.vue?vue&type=style&index=0&id=d09346f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d09346f8",
  null
  
)

export default component.exports